import React from 'react';
import PropTypes from 'prop-types';
import { Box } from '@mui/material';

import ClaimButton from 'src/components/ClaimButton';
import UserSelect from 'src/pages/QueryPages/components/UserSelect';
import DiscardButton from 'src/components/DiscardButton';

const QueryCardActions = ({ query, users, mutate }) => {
  const isNewQuery = query.status === 'new';
  const claimedUser = users?.find((user) => user?.id === query?.userClaimID);

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1.5, mt: 1 }}>
      {!isNewQuery && <UserSelect users={users} selectedUserId={query?.userClaimID} query={query} mutate={mutate} />}

      <Box sx={{ display: 'flex', alignItems: 'center' }}>
        <ClaimButton
          query={query}
          claimedUser={claimedUser}
          mutate={mutate}
          hideAvatar={true}
          sx={{
            flexGrow: 1,
          }}
        />

        <DiscardButton query={query} mutate={mutate} />
      </Box>
    </Box>
  );
};

QueryCardActions.propTypes = {
  query: PropTypes.object.isRequired,
  users: PropTypes.array.isRequired,
  mutate: PropTypes.func.isRequired,
};

export default QueryCardActions;
